module.exports = __webpack_public_path__ + "img/happytable_info1.712503c0.jpg";